export default __webpack_public_path__ + "static/perlite_cropped-276a2bceaee60e3f3f18543bcdd908c4.jpg";